// Optional share client (docs/08 §8.5). Feature-flagged OFF until the Worker in
// worker/ is deployed and SHARE_BASE is set (see DEPLOY.md). With the flag off,
// the Share button never appears and nothing leaves the device.

export const SHARE_ENABLED = false;
// Set to the deployed Worker origin, e.g. "https://loopfield-share.<acct>.workers.dev".
const SHARE_BASE = "";

export interface ProjectShare {
  id: string;
  url: string;
}

/** Share the event-layer song JSON (no audio). */
export async function shareProject(songJson: unknown): Promise<ProjectShare> {
  const res = await fetch(`${SHARE_BASE}/api/song`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(songJson),
  });
  if (!res.ok) throw new Error(`share failed: ${res.status}`);
  const { id } = (await res.json()) as { id: string };
  return { id, url: `${location.origin}/?s=${id}` };
}

export async function fetchProject(id: string): Promise<unknown> {
  const res = await fetch(`${SHARE_BASE}/api/song/${encodeURIComponent(id)}`);
  if (!res.ok) throw new Error(`not found: ${res.status}`);
  const { songJson } = (await res.json()) as { songJson: unknown };
  return songJson;
}

/** Upload an exported clip (full audio) and get a shareable URL. */
export async function shareClip(blob: Blob): Promise<string> {
  const res = await fetch(`${SHARE_BASE}/api/clip`, {
    method: "POST",
    headers: { "content-type": blob.type || "audio/wav" },
    body: blob,
  });
  if (!res.ok) throw new Error(`clip failed: ${res.status}`);
  const { url } = (await res.json()) as { url: string };
  return url;
}

export function sharedIdFromUrl(): string | null {
  return new URLSearchParams(location.search).get("s");
}
